import React from "react";

const PdfButton = ({ url, size }) => {
  return (
    <a
      className="flex gap-4 px-4 py-2 items-center border border-gray-400 border-r-8 border-r-primary rounded-md hover:bg-primary hover:text-white transition-all duration-300 ease-in-out min-w-48 w-48 max-w-48 w"
      href={url}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="size-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
        />
      </svg>
      <div className="flex flex-col gap-1">
        <span className="text-base">عرض الملف</span>
        <small className="text-base">PDF - {size}</small>
      </div>
    </a>
  );
};

export default PdfButton;